import { useCurrencyFormat } from '@gogame/intl-ts';

import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';

export const BudgetAllocated = () => {
  const { budgetAllocated } = useViewStateByResolveName();
  const formatCurrency = useCurrencyFormat();
  return formatCurrency(budgetAllocated);
};
